import { GoabCheckbox, GoabContainer, GoabSpacer } from "@abgov/react-components";

import { useGetEligibleEvacuationCoordinatesQuery } from "../../../store";
import { useGenerationForm } from "../../hooks";

export const PhysicalResidenceSection = () => {
  const { fieldValues, handleEvacuationLocationChange } =
    useGenerationForm("EvacuationLocation");

  const { data: eligibleEvacuationCoordinates } =
    useGetEligibleEvacuationCoordinatesQuery();

  return (
    <>
      <GoabContainer accent="thin">
        <h3>Physical residence on the map</h3>
        <GoabSpacer vSpacing="l" />
        <GoabCheckbox
          name="eligibleEvacuationLocation"
          text="Select an eligible evacuation location?"
          checked={fieldValues.eligibleEvacuationLocation}
          onChange={({name, value}) =>
            handleEvacuationLocationChange(value === "true", eligibleEvacuationCoordinates)
          }
        ></GoabCheckbox>
      </GoabContainer>
      <GoabSpacer vSpacing="2xs" />
    </>
  );
};
